import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { AccordionGroup } from '../accordion-group/accordion-group';
import { List } from '../list/list';
import styles from './sidebar.module.scss';
const SidebarGroups = ({ groups, groupIconColor, groupTitleColor, listMaxHeight, focusable, onSelection, sideBarHeight, sectionsCollapsible, icons, enableSearch, }) => {
    const groupsWrapperStyle = useMemo(() => {
        return {
            height: `${sideBarHeight}px`,
        };
    }, [sideBarHeight]);
    return (_jsx("div", { className: styles.groups_wrapper, style: groupsWrapperStyle, children: _jsx(AccordionGroup, { titles: groups.filter(grp => grp.visible).map(grp => grp.title), expanded: true, autoClose: false, border: false, titleColor: groupTitleColor, iconColor: groupIconColor, isTitleBold: true, disableCollapse: !sectionsCollapsible, icons: icons, fullWidth: true, colorizeHeader: true, headerHeight: 45, children: groups
                .filter(grp => grp.visible)
                .map(({ id, items, title }) => {
                return (_jsx(List, { options: items, border: false, rowGap: 5, itemHeight: 30, maxHeight: listMaxHeight, onSelection: option => onSelection(option, id), noUniqueIds: true, focusable: focusable, showCheckIcon: false, highlightSelection: true, textColor: "#000", backGroundColor: "transparent", label: title, enableSearch: enableSearch, disableBgColor: true }, id));
            }) }) }));
};
SidebarGroups.displayName = 'SidebarGroups';
export { SidebarGroups };
